
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/posts",
      function () {
        return require("private-next-pages/community/posts/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/posts"])
      });
    }
  